export default "/kiban/_next/static/images/top_none-3c5e301d365c18fd1efa9e0c5c9fe254.png";